<template>
<div>
  <div class="extensao_banner">
    <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
  </div>
  <div class="avisosDetalhe">
    <div class="wrap" 
      v-if="aviso != null && aviso != undefined">
      <div class="row align-center">
        <div class="small-12 medium-12 large-12 columns bolsa_detalhe">
          <div class="row">
            <div class="small-12 medium-12 large-12 columns content">
              <avtitle :title="aviso.post_title"/>
              <p v-html="aviso.docaviso_descricao" style="white-space: pre-wrap;"></p>
            </div>
          </div>
          <Files :aviso="aviso"/>
        </div>
      </div>
      <router-link class="button botao_detalhe" to="/avisosecomunicados">
        {{ $t("UMA_LANG_SASUMA_AVISOS_VERTODOSOSAVISOS") }}
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import axios from "@/axios";
import { ref, onMounted } from "vue";
import { i18n } from "@/main.js";
import { useRoute, onBeforeRouteLeave } from 'vue-router';
import BreadCrumb from "@/components/BreadCrumb.vue";
import Files from "@/components/aviso/files.vue";
import avtitle from "@/components/aviso/avtitle.vue";

export default {
  components: {
    BreadCrumb,
    Files,
    avtitle
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    //#region breadcrumb

    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.avisos"), route: { to: "/avisosecomunicados" } }
      ]
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    //#endregion

    const route = useRoute();
    const aviso = ref(null);

    const fetchDocument = () => {
      axios.get(`/docavisos/${route.params.id}?idioma=${lang}`)
      .then(response => {
          aviso.value = response.data;
          const updatedBreadcrumb = [
            ...breadcrumb.value,
            { ID: 6, text: response.data.post_title, href: "#" }
          ];
          breadcrumb.value = updatedBreadcrumb;
      })
      .catch(error => {
          console.log(error);
      });
    }

    fetchDocument()

    return {
      aviso,
      breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .extensao_banner h1 {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}


//#region detalhe
.avisosDetalhe .wrap > .row {
  border: 1px solid #6eb7ec;
  margin-bottom: 40px;
  margin-left: 0;
  margin-right: 0;
}

/*#region Wrap*/
.avisosDetalhe .wrap {
    padding: 0;
    padding-left: 10%;
    padding-right: 10%;
    width: 100%;
    background: #fefefe;
}

@media (min-width: 1400px){
  .avisosDetalhe .wrap {
    padding-left: 15%;
    padding-right: 15%;
    max-width: 100%;
    margin: 0;
  }
}

@media (max-width: 767px){
  .avisosDetalhe .wrap {
    padding-left: 5%;
    padding-right: 5%;
  }
}
/*#endregion*/

/*#region Breadcrumb*/
.avisosDetalhe .breadcrumb {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  top: 12%;
}

@media (max-width: 767px){
  .avisosDetalhe .breadcrumb {
    display: none;
  }
}

/*#endregion*/

/*#region BoxLayout*/

.avisosDetalhe{
  background:#fefefe;
}

.avisosDetalhe .wrap > .row {
  border: 1px solid #a7a5a5;
  margin: 75px 0 40px;
}


@media (max-width: 767px){
  .avisosDetalhe .wrap > .row{
    margin-top: 25px;
  }
}

.content{
  padding-right: 40px;
  padding-left: 50px;
  padding-bottom: 5px;
}

@media screen and (max-width: 767px) {
  .content{
    padding-right: 15px;
    padding-left: 15px;
  }
}


@media (max-width: 767px){
  .avisosDetalhe .bolsa_detalhe {
    padding-right: 0;
    padding-left: 0;
  }
}
/*#endregion*/

/*#region TextLayout*/
.avisosDetalhe .bolsa_detalhe a{
  line-height: 2.25 !important;
  text-decoration: underline !important;
  font-size: 15px;
  display: block;
  padding-top: 7px;
  font-family: "Montserrat Bold";
  color: #707475;
}

.avisosDetalhe .bolsa_detalhe .doc_regulamento_doc a {
  color: #6eb7ec;
  font-size: 14px;
  padding-bottom: 28px;
  font-family: "Montserrat SemiBold";
  line-height: 0.05;
  text-decoration: none !important;
}

@media (max-width: 767px){
  .avisosDetalhe .bolsa_detalhe .doc_regulamento_doc a{
    padding-bottom: 0;
  }
}

.doc_regulamento_doc {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: 5px;
  line-height: 1.3;
  text-align: center;
  margin-bottom: 15px;
}

.avisosDetalhe .bolsa_detalhe .doc_regulamento_doc a:hover {
  font-family: "Montserrat Bold";
}

.avisosDetalhe .bolsa_detalhe h1 {
  font-family: "Montserrat Bold" !important;
  font-size: 24px !important;
  padding-bottom: 10px !important;
  margin-top: 54px !important;
  color: #6eb7ec !important;
}

@media (max-width: 767px) {
  .avisosDetalhe .bolsa_detalhe h1 {
    font-size: 19px !important;
    margin-top: 27px !important;
  }
  .titulo_aviso_detalhe img {
    width: 38px !important;
    margin-left: 16px;
    margin-top: 15px !important;
  }

}

.avisosDetalhe .bolsa_detalhe h5 {
  font-size: 21px;
  color: #535d61;
  margin-bottom: 0;
  font-family: "PT Sans Italic";
}
@media (max-width: 767px) {
  .avisosDetalhe .bolsa_detalhe h5 {
    font-size: 17px;
    padding-bottom: 15px;
    padding-right: 16px;
    padding-left: 16px;
  }
}

.avisosDetalhe .bolsa_detalhe p,
.avisosDetalhe .bolsa_detalhe ul li,
.avisosDetalhe .bolsa_detalhe .content div{
  font-size: 16px !important;
  margin-bottom: 15px !important;
  margin-top: 5px !important;
  font-family: 'PT Sans' !important;
  color: #656565 !important;
}

.avisosDetalhe .bolsa_detalhe ul{
  margin-left: 1.25rem !important;
}

@media (max-width: 767px){
  .avisosDetalhe .bolsa_detalhe p,
  .avisosDetalhe .bolsa_detalhe ul li {
    padding-right: 16px !important;
    padding-left: 16px !important;
    font-size: 14px !important;
    margin-bottom: 20px !important;
  }
}
/*#endregion*/

/*#region Button*/
.avisosDetalhe .botao_detalhe {
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  background-color: #6eb7ec;
}

.avisosDetalhe .button.botao_detalhe {
  padding: 20px;
  margin-bottom: 100px;
  margin-left: 0;
}

@media (max-width: 767px) {
  .avisosDetalhe .button.botao_detalhe {
    margin-left: 0;
    width: 100%;
    padding: 20px;
    margin-bottom: 100px;
  }
}
/*#endregion*/
.titulo_aviso_detalhe {
  display: flex;
}

.titulo_aviso_detalhe img {
  width: 45px;
  margin-top: 42px;
  margin-right: 15px;
}
</style>